export default __webpack_public_path__ + "static/media/arrow.461ca75d.svg";